export default {
    loginWaiting: {
        metaTitle: 'Login Waiting',
        channelLogoAlt: 'Channel logo',
        title: 'Thank you for participating.',
        successVerifyEmail: 'Please check your email to verify your account.',
        successClosePage: 'You can close this page now.',
        createAccountPromptLine1: 'Would you like to create a free account',
        createAccountPromptLine2: 'and make unlimited UGC?',
        createAccountButton: 'Create Account',
        closeTabNote: 'If you prefer not to create an account, you can close this tab.',
    },
    createAccount: {
        metaTitle: 'Create Account',
        logoAlt: '{teamName} logo',
        title: 'Join your team on {teamName}.',
        subtitle: 'Create content. Share feedback. Collaborate with your team.',
        workEmail: 'Work email',
        workEmailPlaceholder: "email{'@'}acme.corp.com",
        firstName: 'First name',
        firstNamePlaceholder: 'First name',
        lastName: 'Last name',
        lastNamePlaceholder: 'Last name',
        titleLabel: 'Title',
        titlePlaceholder: 'Your role',
        department: 'Department',
        selectDepartment: 'Select department',
        password: 'Password',
        passwordPlaceholder: 'Password',
        confirmPassword: 'Confirm password',
        confirmPasswordPlaceholder: 'Re-enter password',
        passwordHint: 'Your password must be at least 10 characters and include a number and symbol.',
        createAccountButton: 'Create Account',
    },
};
